import { Outlet, useParams } from 'react-router'
import { WidgetLayout } from 'components/WidgetLayout'

export const AreaLayout = () => {
  const { areaId } = useParams<{ areaId: string }>()

  return (
    <>
      <Outlet />
      <WidgetLayout areaId={areaId} filterChatsByAreaId={true} />
    </>
  )
}
